import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card, { LigneCard } from '../../Card';
import { estEnCoursDeChargement, toEuros, toDate } from '../../../App_Code/Utils';
import { bindActionCreators } from 'redux';
import * as ProAct from '../../../Actions/ProActions';
import { obtenirProprietaire } from '../../../App_Code/API';
import { ExplicationSolde } from '../../Accueil/CardInfos';
import CardModePaiement from './CardModePaiement';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';

const CardPaiement = ({
    SoldeAct, SoldeExi, LsOperations, PrlAuto,
}) => (
    <Card Titre="Ma comptabilité">
        <div>
            <LigneCard titre="Solde actuel" valeur={toEuros(SoldeAct, true)} classeValeur={`text-right ${SoldeAct < 0 ? ' text-danger' : ' text-success'}`} />
            <LignesOperations LsOperations={LsOperations} />
            <LigneCard valeur={<span>__________</span>} classeValeur="text-right" />
            <LigneCard titre="Solde exigible" classeTitre="font-weight-bold" valeur={toEuros(SoldeExi, true)} classeValeur={`text-right ${SoldeExi < 0 ? ' text-danger' : ' text-success'}`} />
            <ExplicationSolde Solde={SoldeExi} />
            { PrlAuto && SoldeExi < 0 ?
                <div className="alert alert-info">
                    Vous avez opté pour le prélèvement automatique. Le solde dû sera inclus dans l&apos;échéancier qui vous parviendra avec votre prochain prélèvement.<br />
                    <strong>Note :</strong> En cas de rejet de prélèvement, vous pouvez faire l&apos;objet d&apos;une procédure de régularisation.
                </div> : null
            }
        </div>
    </Card >
);

const LignesOperations = ({ LsOperations }) => {
    const lsLignesOp = [];
    LsOperations.forEach((operation, index) => {
        if (operation.Credit > 0) lsLignesOp.push(<LigneCard key={`c${index}`} titre={`${toDate(operation.DateEcr, 'DD/MM/YYYY')} - ${operation.Libelle}`} valeur={`${toEuros(operation.Credit, true)}`} longTitre classeValeur="w-25 text-right" />);
        if (operation.Debit > 0) lsLignesOp.push(<LigneCard key={`d${index}`} titre={`${toDate(operation.DateEcr, 'DD/MM/YYYY')} - ${operation.Libelle}`} valeur={`${toEuros(operation.Debit * -1, true)}`} longTitre classeValeur="w-25 text-right text-danger" />);
    });
    lsLignesOp.reverse();

    return (
        <div>
            <LigneCard titre="Opérations à venir : " />
            <div className="ml-3">
                {lsLignesOp.length > 0 ? lsLignesOp : <LigneCard valeur="néant" classeValeur="text-right text-muted" />}
            </div>
        </div>);
};

class PagePaiement extends Component {
    constructor(props) {
        super(props);

        let num = parseFloat(this.props.Cpt.Solde);
        num *= -1;
        const SoldeAPrl = num.toFixed(2);

        this.state = {
            autreModePaiement: 0,
            choixModePaiement: 0,
            SoldeActuel: 0,
            LsOperations: [],
            SoldeAPrl,
        };

        this.setSoldeAPrl = this.setSoldeAPrl.bind(this);
    }

    componentWillMount(){
        //Mise a jour du pro dès qu'on arrive sur la page
        obtenirProprietaire().then((pro) => {
            this.props.actions.proAjout(pro);
        })
        // Récupération des lignes "operations à venir"
        const { Historique, Cpt } = this.props;
        // Si l'historique est chargé sinon retour sur mes infos
        if (estEnCoursDeChargement(Historique)) {
            this.props.history.push('/MesInformations');
            return;
        }

        const lsLignesHisto = [];
        let solde = Cpt.Solde;

        Historique.forEach((ligneHisto) => {
            if (ligneHisto.Etat === 0) {
                lsLignesHisto.push(ligneHisto);
                if (ligneHisto.Credit > 0) solde -= ligneHisto.Credit;
                if (ligneHisto.Debit > 0) solde += ligneHisto.Debit;
            }
        });
        this.setState({ LsOperations: lsLignesHisto, SoldeActuel: solde });
    }

    setSoldeAPrl = (value) => {
        this.setState({ SoldeAPrl: value });
    }

    setChoixModePaiement = (value) => {
        this.setState({ choixModePaiement: value });
    }

    setAutreModePaiement = (value) => {
        this.setState({ autreModePaiement: value });
    }

    render() {
        const { Cpt, Mandat } = this.props;
        const prlAuto = Mandat.PrlOk && (Mandat.ModePrl === 1 || Mandat.ModePrl === 2);

        return (
            <div style={{ maxWidth: 700, margin: 'auto' }}>
                <CardPaiement SoldeAct={this.state.SoldeActuel} SoldeExi={Cpt.Solde} LsOperations={this.state.LsOperations} PrlAuto={prlAuto} />
                <CardModePaiement setChoix={this.setChoixModePaiement} choixModePaiement={this.state.choixModePaiement} setAutreChoix={this.setAutreModePaiement} autreModePaiement={this.state.autreModePaiement} SoldeAPayer={Cpt.Solde * -1} SoldeAPrl={this.state.SoldeAPrl} setSoldeAPrl={this.setSoldeAPrl} history={this.props.history} />    
            </div>
        );
    }
}
PagePaiement.displayName = 'PagePaiement';
PagePaiement.requiredProps = [
    'Historique', // historique du pro
    'Cpt', // Cpt du pro
    'Mandat', // Mandat du pro
];

function mapStateToProps({
    ProStore: {
        Historique,
        Pro: { Cpt, Mandat },
    },
}) {
    return {
        Historique, Cpt, Mandat,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PagePaiement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/PagePaiement.js